/**
 * 定数定義
 */
export default {

    FUNCTION_ID: "fid=",
    LOCAL_HOST: "localhost:8080",

    INDEX_TITLE: "入会手続きの確認",
    COMPLETE_TITLE: "メール送信完了",
    ERROR_TITLE: "エラー",

  };
